export const INVITATION_DELAY_MS = 60_000
export const INVITATION_IDLE_MS = 15_000
export const INVITATION_COOLDOWN_MS = 30 * 24 * 60 * 60 * 1000
const FIRST_DAY_MS = 24 * 60 * 60 * 1000

export type InvitationHistory = {
  firstSeenAt: number
  sessions: number
  impressions: number
  lastShownAt: number
  never: boolean
}

/** Estos intervalos son decisiones del producto, no cifras universales de UX. */
export function canInvite(history: InvitationHistory, now: number): boolean {
  return !history.never && history.sessions >= 2 && history.impressions < 3
    && now - history.firstSeenAt >= FIRST_DAY_MS
    && (history.lastShownAt === 0 || now - history.lastShownAt >= INVITATION_COOLDOWN_MS)
}

export const invitationKey = (userId: string) => `veltica:plan-invitation:${userId}`
export const invitationSessionKey = (userId: string) => `${invitationKey(userId)}:session`

export function readInvitation(userId: string, now: number): InvitationHistory {
  const raw = window.localStorage.getItem(invitationKey(userId))
  if (raw) {
    const value = JSON.parse(raw) as InvitationHistory
    if ([value.firstSeenAt, value.sessions, value.impressions, value.lastShownAt].every((number) => Number.isFinite(number) && number >= 0) && typeof value.never === 'boolean') return value
  }
  // Respetar también el cierre del antiguo cartel mientras se migra al diálogo.
  let lastShownAt = 0
  try {
    const old = JSON.parse(window.localStorage.getItem('veltica_sidebar_upgrade_dismissed') ?? 'null')
    if (old?.kind === 'free' && Number.isFinite(old.dismissedAt)) lastShownAt = old.dismissedAt
  } catch { /* Sin una decisión anterior válida. */ }
  return { firstSeenAt: now, sessions: 0, impressions: 0, lastShownAt, never: false }
}
